var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "shared-radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": _vm.id,
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.modelValue === _vm.value
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('change', $event.target.value);
      }
    }
  }), _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }